import { render, staticRenderFns } from "./HdIndex.vue?vue&type=template&id=bf0bb1b0&"
import script from "./HdIndex.vue?vue&type=script&lang=js&"
export * from "./HdIndex.vue?vue&type=script&lang=js&"
import style0 from "./HdIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports